import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { ShippingProvider } from "./context/ShippingContext";
import App from "./App";
import "./index.css";

const appVersion = process.env.REACT_APP_VERSION || "0.1.0";
console.log(`Trirebels app version: ${appVersion}`);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.PUBLIC_URL || ""}>
      <CartProvider>
        <ShippingProvider>
          <App />
        </ShippingProvider>
      </CartProvider>
    </BrowserRouter>
  </React.StrictMode>
);
